import * as React from 'react';
import TableBusinessData from './components/tableBusinessData';

const Business = () => {
  return (
    <TableBusinessData />
  );
};
export default Business;
